export default {
  data: () => ({
    validationErrors: {},
  }),
  methods: {
    setValidationErrors: function (validationErrors) {
      const errors = { ...this.validationErrors }

      this.$_.map(validationErrors, (val, key) => {
        const splittedkeys = key.split('.')
        splittedkeys.splice(0, 1)
        let error = val[0]
        const errorSplits = error.split(' ')
        const firstWordIsAttribute = errorSplits.length > 1 && errorSplits[0].indexOf('.')

        if (firstWordIsAttribute) {
          const indexOfFirstWordEnd = error.indexOf(' ')
          const attributeSplits = errorSplits[0].split('.')
          const localeKey = attributeSplits.length > 1 ? attributeSplits[1] : attributeSplits[0]

          error = `${this.$t(localeKey)} ${error.substring(indexOfFirstWordEnd)}`
        }

        this.$_.set(errors, splittedkeys, this.$_.capitalize(error))
      })
      this.validationErrors = errors
    },

  },
}
